





































import {
  computed,
  defineComponent,
  InjectionKey,
  provide,
  reactive,
  ref,
  toRef,
} from '@nuxtjs/composition-api'
import { BackdropOverlayZIndex } from '~/composables/ui/useBackdropOverlay'
import {
  SidebarDiretion,
  SidebarConfig,
  useSidebar,
} from '~/composables/ui/useSidebar'

export type SidebarContext = {
  global: boolean
}

export const sidebarContextKey: InjectionKey<SidebarContext> =
  Symbol('sidebarContextKey')

export default defineComponent({
  name: 'AppSidebar',

  props: {
    global: {
      type: Boolean,
      default: true,
    },
    visible: {
      type: Boolean,
      default: true,
    },
    currentName: {
      type: String,
      default: undefined,
    },
  },

  setup(props) {
    const zIndex = BackdropOverlayZIndex.Z60
    const { current, visible: globalVisible } = useSidebar()

    const containerVisible = ref(false)

    const onBeforeEnter = () => {
      containerVisible.value = true
    }

    const onAfterLeave = () => {
      containerVisible.value = false
    }

    const direction = computed(() => {
      const currentName = props.global ? current.value.name : props.currentName

      return (
        (currentName && SidebarConfig.get(currentName)?.diretion) ??
        SidebarDiretion.Right
      )
    })

    const finalVisible = computed(() =>
      props.global ? globalVisible.value : props.visible
    )

    provide(
      sidebarContextKey,
      reactive({
        global: toRef(props, 'global'),
      })
    )

    return {
      current,
      containerVisible,
      finalVisible,
      direction,
      zIndex,

      onBeforeEnter,
      onAfterLeave,
    }
  },
})
